import styled from 'styled-components'
import { CoveredImageBox } from '../../boxes/ImageBox'
import { SIZES } from '../../../constants'

export default styled(CoveredImageBox)`
  position: relative;
  & .image-column {
    position: relative;
  }
  & img {
    max-height: 294px;
    width: 100%;
  }
  & .title-column span {
    background-color: ${props => props.theme.dynamicLead.firstBox.backgroundColor};
    color: ${props => props.theme.dynamicLead.firstBox.color};
    display: block;
    font-size: 17px;
    height: 76px;
    line-height: 20px;
    overflow: hidden;
    padding: 7px 15px;
    text-overflow: ellipsis;
  }
  &:hover {
    text-decoration: none;
  }
  @media (max-width: ${SIZES.BREAKPOINT_XS - 1}px) {
    display: flex;
    display: -ms-flexbox;
    flex: 1;
    & .image-column {
      display: flex;
      display: -ms-flexbox;
      flex: 1 1 0;
      -ms-flexbox: 1 1 0;
      padding: 0;
      width: 160px;
    }
    & img {
      height: 120px;
      width: 160px;
    }
    & .title-column {
      display: flex;
      display: -ms-flexbox;
      padding: 0;
    }
    & .title-column span {
      background: none;
      color: #333;
      font-size: 14px;
      height: auto;
      padding: 0 0 0 10px;
      width: 100%;
    }
    &:hover {
      text-decoration: underline;
    }
    &:hover .title-column span {
      color: inherit;
    }
  }
  @media (min-width: ${SIZES.BREAKPOINT_XS}px) {
    display: flex;
    display: -ms-flexbox;
    flex: 1;
    -ms-flexbox: 1;
    flex-direction: column;
    -ms-flex-direction: column;
    & .image-column {
      display: flex;
      display: -ms-flexbox;
      flex: auto;
      -ms-flexbox: auto;
    }
  }
`
